module.exports = __webpack_public_path__ + "img/c19.c42209e2.png";